<template>
  <div
    class="tw-flex tw-justify-between tw-items-center tw-w-full tw-flex-wrap"
  >
    <div
      class="tw-text-[#231F20] tw-text-[14px] tw-not-italic tw-font-medium tw-leading-[145%] question tw-w-[241px]"
    >
      <span>{{ title }}</span>
      <span v-if="required" class="tw-text-[red]">&nbsp;*</span>
    </div>
    <div
      class="tw-flex tw-w-[50%] tw-items-center tw-gap-[60px] tw-px-0 tw-py-[18px] answer"
    >
      <BaseCheckbox
        :text="
          textLeft
            ? textLeft
            : getComponentUiText(
                'app-menu-submenu-home-setup-wizard-radio-button-title-yes-1',
              )
        "
        :color="
          isApiError && state === assessmentAnswerType1State.yes
            ? '#F7553C'
            : '#387DFF'
        "
        :un-selected-color="
          isApiError && state === assessmentAnswerType1State.yes
            ? '#F7553C'
            : '#DBDBDB'
        "
        :ticked="state === assessmentAnswerType1State.yes"
        :not-yes-no="notYesNo"
        :disabled="!disabled ? '' : answer"
        :text-left="textLeft"
        :text-style="
          isApiError && state === assessmentAnswerType1State.yes
            ? 'tw-text-[#F7553C]'
            : ''
        "
        data-cy="yes"
        @selected="() => handleState(assessmentAnswerType1State.yes)"
        @unselected="() => handleState(assessmentAnswerType1State.unselected)"
      />
      <BaseCheckbox
        :text="
          textRight
            ? textRight
            : getComponentUiText(
                'app-menu-submenu-home-setup-wizard-radio-button-title-no-1',
              )
        "
        :color="
          isApiError && state === assessmentAnswerType1State.no
            ? '#F7553C'
            : '#387DFF'
        "
        :un-selected-color="
          isApiError && state === assessmentAnswerType1State.no
            ? '#F7553C'
            : '#DBDBDB'
        "
        :ticked="state === assessmentAnswerType1State.no"
        :disabled="!disabled ? '' : answer"
        :not-yes-no="notYesNo"
        :text-left="textLeft"
        :text-style="
          isApiError && state === assessmentAnswerType1State.no
            ? 'tw-text-[#F7553C]'
            : ''
        "
        data-cy="no"
        @selected="() => handleState(assessmentAnswerType1State.no)"
        @unselected="() => handleState(assessmentAnswerType1State.unselected)"
      />
    </div>
  </div>

  <div class="tw-flex">
    <div class="md:tw-flex md:tw-w-[50%]"></div>
    <div v-if="mesageError" class="tw-flex md:tw-w-[50%] tw-w-[100%] invalid">
      {{ getComponentUiText("app-setting-org-detail-required-fields-1") }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { assessmentAnswerType1State } from "@/utils/constants";
import BaseCheckbox from "../common/form/baseCheckbox.vue";
import { onMounted, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  required: {
    type: Boolean,
    default: false,
  },
  answer: {
    type: [Number, String],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: true,
  },
  textLeft: {
    type: String,
    default: "",
  },
  textRight: {
    type: String,
    default: "",
  },
  notYesNo: {
    type: Boolean,
    default: false,
  },

  mesageError: {
    type: Boolean,
    default: false,
  },

  isApiError: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const state: any = ref(props.answer);

const emits = defineEmits(["onUpdate", "update:answer"]);

const handleState = (value: number | string) => {
  if (props.answer !== null && !state.value && !isMounted) return;
  state.value = value;
  emits("onUpdate", value);
  emits("update:answer", value);
};

watch(
  () => props.answer,
  (newValue, oldValue) => {
    // if (newValue) {
    state.value = newValue;
    handleState(newValue);
    // }
  },
  { deep: true },
);
let isMounted = false;
onMounted(() => {
  setTimeout(() => {
    isMounted = true;
  }, 500);
});
</script>

<style scoped>
.question {
  position: relative;
}
/* .question::after {
  content: "*";
  position: relative;
  right: -4px;
  top: -2px;
  color: #f7553c;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
} */
.invalid {
  font-size: 11px !important;
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: 500 !important;
  color: #f7553c !important;
  line-height: 130% !important;
  position: relative;
  top: -10px;
}
@media screen and (max-width: 600px) {
  .answer {
    gap: 20px;
    width: 100%;
    flex-direction: column;
    place-items: flex-start;
  }
}
</style>
